import { writable } from 'svelte/store';

export const notificationStore = writable({
    message: '',
    type: 'error',
    duration: 3000
});

export function showNotification(message, type = 'error', duration = 5000) {
    notificationStore.set({
        message,
        type,
        duration
    });
} 
